import { Box, chakra, Flex, Text } from '@chakra-ui/react';
import { ServiceProductItem } from 'model/modules/services/serviceProductItem';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';

interface Props {
  product: ServiceProductItem;
}

const ServiceProductGridItem: FC<Props> = ({ product, ...props }) => {
  const navigate = useNavigate();
  const textShadow = '0px 4px 11px rgba(0, 0, 0, 0.3)';

  const handleClick = (): void => {
    navigate(AppRoute.serviceProductDetail(product.id));
  };

  return (
    <AppCard
      overflow="hidden"
      cursor="pointer"
      h="230px"
      p="15px"
      position="relative"
      bgColor={product.primaryColor}
      onClick={handleClick}
      {...props}
    >
      <Box
        position="absolute"
        right="0"
        top="0"
        w="230px"
        h="230px"
        bgImage={product.coverImageUrl ? `url(${product.coverImageUrl})` : undefined}
        bgSize="cover"
        bgPosition="center"
        bgRepeat="no-repeat"
        borderTopRightRadius="inherit"
        borderBottomRightRadius="inherit"
      >
        <Box
          position="absolute"
          top="0"
          left="0"
          w="100%"
          h="100%"
          bg={product.primaryColor}
          opacity={0.6}
          mixBlendMode="multiply"
          borderTopRightRadius="inherit"
          borderBottomRightRadius="inherit"
        />
      </Box>
      <Flex
        h="100%"
        zIndex={5}
        position="relative"
        flexDir="column"
        justifyContent="flex-end"
      >
        <Text
          textShadow={textShadow}
          color={Color.OnPrimary}
          fontWeight={800}
          fontSize="22px"
          mb="5px"
        >
          {product.title}
        </Text>
        <Text
          textShadow={textShadow}
          color={Color.OnPrimary}
          fontWeight={700}
          fontSize="26px"
          mb="5px"
        >
          {product.subtitle}
        </Text>
        {product.subtitle2 && (
          <Text
            textShadow={textShadow}
            color={Color.OnPrimary}
            fontWeight={700}
            fontSize={FontSize.sm}
          >
            {product.subtitle2}
          </Text>
        )}
      </Flex>
    </AppCard>
  );
};

export default chakra(ServiceProductGridItem);
